import React, { useContext, useState, 
  // useRef
} from "react";
import DashboardContext from "../../../contexts/DashboardContext";
import Loading from "../../Shared/ResourceIndex/Loading";
// import _ from 'lodash';
import SideFilterMenu from "../shared/SideFilterMenu/SideFilterMenu";
import ProjectsChartWidget from "../shared/ChartWidget/ProjectsChartWidget/ProjectsChartWidget";
import MissedInspectionsChartWidget from "../shared/ChartWidget/MissedInspectionsChartWidget/MissedInspectionsChartWidget";
import OverdueFindingsChartWidget from "../shared/ChartWidget/OverdueFindingsChartWidget/OverdueFindingsChartWidget";

const DivisionalSpecifics = (props) => {
  const { setTabIndex } = props
  const { divisionalSpecificsForCM, isLoadingDivisionalSpecificsForCM } = useContext(DashboardContext)
  const [ selectedOverdueThreshold, setSelectedOverdueThreshold ] = useState(7)
  const [ selectedDivisionValue, setSelectedDivisionValue ] = useState("All Divisions");
  // const searchRef = useRef(null);
  // const { setqueryParamsForDivisionalSpecificsCM } = useContext(DashboardContext)

  let totalCounts = 0

  // const handleSearchFunc = _.debounce((event) => {
  //   setqueryParamsForDivisionalSpecificsCM({s: event.target.value})
  // }, 500);

  const allDivisionsCummulativeCounts = () => {
    const allDivisionsData = divisionalSpecificsForCM && divisionalSpecificsForCM.reduce((acc, ele) => {
      acc.allDivisionsTotalProjectsCount += ele.totalProjectsCount
      acc.allDivisionsTotalInspectionsCount += ele.totalInspectionsCount
      acc.allDivisionsMissedInspectionsCount += ele.missedInspectionsCount
      acc.allDivisionsTotalFindingsCount += ele.totalFindingsCount
      acc.allDivisionsOverdueFindingsCount += ele.overdueFindingsCount

      return acc
      },
      { 
        allDivisionsName: "All Divisions",
        allDivisionsTotalProjectsCount: 0,
        allDivisionsTotalInspectionsCount: 0,
        allDivisionsMissedInspectionsCount: 0,
        allDivisionsTotalFindingsCount: 0,
        allDivisionsOverdueFindingsCount: 0
      }
    )

    totalCounts = allDivisionsData
    const { allDivisionsName, allDivisionsTotalProjectsCount, allDivisionsTotalInspectionsCount, allDivisionsMissedInspectionsCount, allDivisionsTotalFindingsCount, allDivisionsOverdueFindingsCount } = allDivisionsData

    return(
      <div className="divisional-specifics__table-body">
        <li>{allDivisionsName}</li>
        <li>{allDivisionsTotalProjectsCount}</li>
        <li>{allDivisionsTotalInspectionsCount}</li>
        <li>{allDivisionsMissedInspectionsCount}</li>
        <li>{allDivisionsTotalFindingsCount}</li>
        <li>{allDivisionsOverdueFindingsCount}</li>
        <li><span onClick={() => {
          setTabIndex(3)
          localStorage.setItem('dashboardTabLastSelected', 3)
        }}>View Projects</span></li>
      </div>
    )
  }
  
  return (
    <div className="divisional-specifics__outer-outer-wrapper">
      <SideFilterMenu tabName={'Division Overview'} setSelectedOverdueThreshold={setSelectedOverdueThreshold} setSelectedDivisionValue={setSelectedDivisionValue}/>

      <div className="divisional-specifics__outer-wrapper">
        <div className="divisional-specifics">
          {/* <input className="divisional-specifics__search-bar" ref={searchRef} onChange={(event) => handleSearchFunc(event)} placeholder="Search" /> */}

          <div className="divisional-specifics__content">
          <div className="divisional-specifics__table-head">
            <h3>Division </h3>
            <h3>Total Projects </h3>
            <h3>Total Inspections </h3>
            <h3>Missed Inspections </h3>
            <h3>Total Findings </h3>
            <h3>Overdue Findings </h3>
            <h3>Action </h3>
          </div>

          {
            !isLoadingDivisionalSpecificsForCM ?
              (
                <>
                  {allDivisionsCummulativeCounts()}
                  {divisionalSpecificsForCM && divisionalSpecificsForCM.map((ele, index) => {
                    return (
                      <div key={index} className="divisional-specifics__table-body">
                        <li>{ele.divisionName}</li>
                        <li>{ele.totalProjectsCount}</li>
                        <li>{ele.totalInspectionsCount}</li>
                        <li>{ele.missedInspectionsCount}</li>
                        <li>{ele.totalFindingsCount}</li>
                        <li>{ele.overdueFindingsCount}</li>
                        <li><span onClick={() => {
                          setTabIndex(3)
                          localStorage.setItem('dashboardTabLastSelected', 3)
                        }}>View Projects</span></li>
                      </div>
                    )
                  })}
                </>
              ):
              (<Loading what="data" />)
          }
          </div>
        </div>
      </div>

      <div className="regions__charts">
        <ProjectsChartWidget data={divisionalSpecificsForCM} nameKey="divisionName" dataKey="totalProjectsCount" headerTotalCount={totalCounts.allDivisionsTotalProjectsCount} selectedDivisionValue={selectedDivisionValue}/>
        <MissedInspectionsChartWidget totalCounts={totalCounts}/>
        <OverdueFindingsChartWidget totalCounts={totalCounts} selectedOverdueThreshold={selectedOverdueThreshold}/>
      </div>
    </div>
  );
};

export default DivisionalSpecifics;
